import type { JSX } from 'react';

import { Card } from '@change-corgi/design-system-legacy/components/content';

import { useDashboardReskinExperiment } from '../../../../../../hooks/useDashboardReskinExperiment';

import { RecentSupportersList } from './components/RecentSupportersList';
import { RecentSupporters as RecentSupportersNew } from './index_new';

export function RecentSupporters(): JSX.Element {
	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();

	if (isEnabled) {
		return <RecentSupportersNew />;
	}

	return (
		<Card
			as="section"
			backgroundColor="white"
			sx={{ border: 'unset', display: 'flex', flexDirection: 'column', borderRadius: 'big', marginBottom: '16px' }}
			data-qa="recent-supporters-module"
		>
			<RecentSupportersList />
		</Card>
	);
}
